import styled from 'styled-components/macro'
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary'

const StyledExpansionPanelSummary = styled(ExpansionPanelSummary)`
  min-height: 48px;
`

export default StyledExpansionPanelSummary
